import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-416948bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://en.wikipedia.org/wiki/Monty_Hall_problem",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("h1", null, "Monty Hall Problem")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Suppose you're on a game show, and you're given the choice of three doors: Behind one door is a car; behind the others, goats. ", -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const headerClassName = "header";

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(headerClassName)
  }, _hoisted_3))
}
}

})